import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=71ce3e5c&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=ts&"
export * from "./Scene.vue?vue&type=script&lang=ts&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=71ce3e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce3e5c",
  null
  
)

export default component.exports